import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CompanySelectDialogComponent } from './company-select-dialog.component';

@NgModule({
  declarations: [CompanySelectDialogComponent],
  imports: [CommonModule, MatFormFieldModule, MatButtonModule, MatSelectModule, MatProgressSpinnerModule],
  exports: [CompanySelectDialogComponent],
})
export class CompanySelectDialogModule {}
